import {Link} from "react-router-dom";

const AccountItem = ({account}) => {
    const to = `/account?id=${account.account_id}`
  return (
    <Link to={to} className="accounts-navlink">
      <div className="accounts-accountitem1">
        <div className="accounts-container08">
          <span className="accounts-text05">{account.phone_number}</span>
        </div>
        <div className="accounts-container09">
          <span className="accounts-text06">{account.name}</span>
        </div>

        {account.status == "connected" ? (
          <div className="accounts-container15">
            <svg viewBox="0 0 1024 1024" className="accounts-icon06">
              <path d="M864 128l-480 480-224-224-160 160 384 384 640-640z"></path>
            </svg>
            <span className="accounts-text12">Connected</span>
          </div>
        ) : account.status == "qr screen" ? (
          <div className="accounts-container14">
            <svg viewBox="0 0 1024 1024" className="accounts-icon04">
              <path d="M1024 384h-384l143.53-143.53c-72.53-72.526-168.96-112.47-271.53-112.47s-199 39.944-271.53 112.47c-72.526 72.53-112.47 168.96-112.47 271.53s39.944 199 112.47 271.53c72.53 72.526 168.96 112.47 271.53 112.47s199-39.944 271.528-112.472c6.056-6.054 11.86-12.292 17.456-18.668l96.32 84.282c-93.846 107.166-231.664 174.858-385.304 174.858-282.77 0-512-229.23-512-512s229.23-512 512-512c141.386 0 269.368 57.326 362.016 149.984l149.984-149.984v384z"></path>
            </svg>
            <span className="accounts-text11">Qr screen</span>
          </div>
        ) : (
          <div className="accounts-container10">
            <svg viewBox="0 0 1024 1024" className="accounts-icon">
              <path d="M1014.662 822.66c-0.004-0.004-0.008-0.008-0.012-0.010l-310.644-310.65 310.644-310.65c0.004-0.004 0.008-0.006 0.012-0.010 3.344-3.346 5.762-7.254 7.312-11.416 4.246-11.376 1.824-24.682-7.324-33.83l-146.746-146.746c-9.148-9.146-22.45-11.566-33.828-7.32-4.16 1.55-8.070 3.968-11.418 7.31 0 0.004-0.004 0.006-0.008 0.010l-310.648 310.652-310.648-310.65c-0.004-0.004-0.006-0.006-0.010-0.010-3.346-3.342-7.254-5.76-11.414-7.31-11.38-4.248-24.682-1.826-33.83 7.32l-146.748 146.748c-9.148 9.148-11.568 22.452-7.322 33.828 1.552 4.16 3.97 8.072 7.312 11.416 0.004 0.002 0.006 0.006 0.010 0.010l310.65 310.648-310.65 310.652c-0.002 0.004-0.006 0.006-0.008 0.010-3.342 3.346-5.76 7.254-7.314 11.414-4.248 11.376-1.826 24.682 7.322 33.83l146.748 146.746c9.15 9.148 22.452 11.568 33.83 7.322 4.16-1.552 8.070-3.97 11.416-7.312 0.002-0.004 0.006-0.006 0.010-0.010l310.648-310.65 310.648 310.65c0.004 0.002 0.008 0.006 0.012 0.008 3.348 3.344 7.254 5.762 11.414 7.314 11.378 4.246 24.684 1.826 33.828-7.322l146.746-146.748c9.148-9.148 11.57-22.454 7.324-33.83-1.552-4.16-3.97-8.068-7.314-11.414z"></path>
            </svg>
            <span className="accounts-text07">Inactive</span>
          </div>
        )}

        {account.subscription_status == "active" ? (
          <div className="accounts-container15">
            <svg viewBox="0 0 1024 1024" className="accounts-icon06">
              <path d="M864 128l-480 480-224-224-160 160 384 384 640-640z"></path>
            </svg>
            <span className="accounts-text12">{account.subscription_status}</span>
          </div>
        ) : (
          <div className="accounts-container10">
            <svg viewBox="0 0 1024 1024" className="accounts-icon">
              <path d="M1014.662 822.66c-0.004-0.004-0.008-0.008-0.012-0.010l-310.644-310.65 310.644-310.65c0.004-0.004 0.008-0.006 0.012-0.010 3.344-3.346 5.762-7.254 7.312-11.416 4.246-11.376 1.824-24.682-7.324-33.83l-146.746-146.746c-9.148-9.146-22.45-11.566-33.828-7.32-4.16 1.55-8.070 3.968-11.418 7.31 0 0.004-0.004 0.006-0.008 0.010l-310.648 310.652-310.648-310.65c-0.004-0.004-0.006-0.006-0.010-0.010-3.346-3.342-7.254-5.76-11.414-7.31-11.38-4.248-24.682-1.826-33.83 7.32l-146.748 146.748c-9.148 9.148-11.568 22.452-7.322 33.828 1.552 4.16 3.97 8.072 7.312 11.416 0.004 0.002 0.006 0.006 0.010 0.010l310.65 310.648-310.65 310.652c-0.002 0.004-0.006 0.006-0.008 0.010-3.342 3.346-5.76 7.254-7.314 11.414-4.248 11.376-1.826 24.682 7.322 33.83l146.748 146.746c9.15 9.148 22.452 11.568 33.83 7.322 4.16-1.552 8.070-3.97 11.416-7.312 0.002-0.004 0.006-0.006 0.010-0.010l310.648-310.65 310.648 310.65c0.004 0.002 0.008 0.006 0.012 0.008 3.348 3.344 7.254 5.762 11.414 7.314 11.378 4.246 24.684 1.826 33.828-7.322l146.746-146.748c9.148-9.148 11.57-22.454 7.324-33.83-1.552-4.16-3.97-8.068-7.314-11.414z"></path>
            </svg>
            <span className="accounts-text07">{account.subscription_status}</span>
          </div>
        )}
      </div>
    </Link>
  );
};

//   const AccountsList = ({ accounts }) => {
//     return (
//       <div>
//         {accounts.map((account) => (
//           <AccountItem key={account.id} account={account} />
//         ))}
//       </div>
//     );
//   };

//   // Example usage
//   const accountData = [
//     {
//       id: 1,
//       name: 'Account 1',
//       status: 'Active',
//       subscription_status: 'Subscribed',
//     },
//     {
//       id: 2,
//       name: 'Account 2',
//       status: 'Inactive',
//       subscription_status: 'Not Subscribed',
//     },
//   ];

//   const YourComponent = () => {
//     return (
//         <AccountsList accounts={accountData} />
//     );
//   };

export default AccountItem;
